import apiClient from './apiClient';
import { saveOffline, getOfflineData, deleteOfflineData, STORES } from '../utils/offlineDB';

export const unterschriftApi = {
  // Unterschrift erstellen (mit Offline-Support)
  create: async (data) => {
    try {
      if (navigator.onLine) {
        const response = await apiClient.post('/unterschriften', data);
        return response.data;
      }

      // Offline: In Queue speichern
      console.log('📴 Unterschrift offline gespeichert');
      const offlineId = await saveOffline(STORES.UNTERSCHRIFTEN, {
        ...data,
        offlineId: 'offline-' + Date.now()
      });

      return {
        message: 'Offline gespeichert - wird synchronisiert',
        offline: true,
        unterschrift: {
          id: 'offline-' + offlineId,
          ...data,
          datum: new Date().toISOString()
        }
      };

    } catch (error) {
      // Bei Netzwerk-Fehler: Offline speichern
      if (error.code === 'ERR_NETWORK' || !navigator.onLine) {
        console.log('📴 Unterschrift offline gespeichert (Fehler)');
        const offlineId = await saveOffline(STORES.UNTERSCHRIFTEN, {
          ...data,
          offlineId: 'offline-' + Date.now()
        });

        return {
          message: 'Offline gespeichert',
          offline: true,
          unterschrift: {
            id: 'offline-' + offlineId,
            ...data,
            datum: new Date().toISOString()
          }
        };
      }
      throw error;
    }
  },

  // Alle Unterschriften einer Anfrage laden
  getByAnfrage: async (anfrageId) => {
    const response = await apiClient.get(`/unterschriften/anfrage/${anfrageId}`);
    return response.data;
  },

  // Alle Unterschriften eines Projekts laden
  getByProjekt: async (projektId) => {
    const response = await apiClient.get(`/unterschriften/projekt/${projektId}`);
    return response.data;
  },

  // Einzelne Unterschrift laden
  get: async (id) => {
    const response = await apiClient.get(`/unterschriften/${id}`);
    return response.data;
  },

  // Unterschrift als PNG herunterladen
  download: async (id) => {
    const response = await apiClient.get(`/unterschriften/${id}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Unterschrift löschen
  delete: async (id) => {
    const response = await apiClient.delete(`/unterschriften/${id}`);
    return response.data;
  },

  // Notizen aktualisieren
  updateNotizen: async (id, notizen) => {
    const response = await apiClient.put(`/unterschriften/${id}`, { notizen });
    return response.data;
  },

  // Erlaubte Typen abfragen
  getTypen: async () => {
    const response = await apiClient.get('/unterschriften/typen');
    return response.data;
  },

  // NEU: Sync pending unterschriften
  syncOfflineData: async () => {
    if (!navigator.onLine) {
      console.log('Noch offline - kann nicht synchronisieren');
      return { synced: 0, failed: 0 };
    }

    try {
      const pendingData = await getOfflineData(STORES.UNTERSCHRIFTEN);
      let synced = 0;
      let failed = 0;

      for (const item of pendingData) {
        try {
          // Die eigentlichen Daten sind in item.data gespeichert
          const data = item.data;

          // Entferne offlineId vor dem Senden
          // eslint-disable-next-line no-unused-vars
          const { offlineId, ...cleanData } = data;

          await apiClient.post('/unterschriften', cleanData);
          await deleteOfflineData(STORES.UNTERSCHRIFTEN, item.id);
          synced++;
          console.log('✅ Unterschrift synchronisiert:', item.id);
        } catch (error) {
          failed++;
          console.error('❌ Unterschrift sync failed:', item.id, error.message);
        }
      }

      return { synced, failed, total: pendingData.length };
    } catch (error) {
      console.error('Offline sync error:', error);
      return { synced: 0, failed: 0, error: error.message };
    }
  },

  // Anzahl der ausstehenden Offline-Einträge
  getPendingOfflineCount: async () => {
    try {
      const pendingData = await getOfflineData(STORES.UNTERSCHRIFTEN);
      return pendingData.length;
    } catch (error) {
      return 0;
    }
  }
};

export default unterschriftApi;
